if (!window.customElements.get("swatch-dropdown")) {
  class SwatchDropdown extends HTMLElement {
    constructor() {
      super();

      this.spanFor = this.dataset.spanFor;
      this.dropdown = this.parentElement.querySelector(".select-custom__inner");

      if (this.spanFor) {
        this.addEventListener("click", this.activeFilterSort.bind(this), false);
      }

      this.setDropdownHeight();
    }

    setDropdownHeight() {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this.dropdown) {
            this.parentElement.style.setProperty("--dropdown-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this.dropdown);
    }

    activeFilterSort() {
      const spanBlock = this.querySelector(`#${this.spanFor}`);

      if (!spanBlock) {
        return;
      }

      if (spanBlock.classList.contains("active")) {
        spanBlock.classList.remove("active");
      } else {
        spanBlock.classList.add("active");
      }
    }
  }

  customElements.define("swatch-dropdown", SwatchDropdown);
}


if (!window.customElements.get("sticky-atc-bar")) {
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.section = document.querySelector(`.product-section[data-section-id="${this.sectionId}"]`);
      this.position = this.dataset.position;
      this.select = this.querySelector(".sticky-atc-bar__select");
      this.image = this.querySelector(".sticky-atc-bar__image img");
      this.atcButton = this.section.querySelector(".button_buy-now");
      this.mainForm = this.atcButton.closest("form");
      this.mainVariants = this.section.querySelectorAll("variant-radios-detail fieldset");
      this.variantsData = this.querySelector(".product-variants-json");
      this.variantsJSON = this.variantsData ? JSON.parse(this.variantsData.textContent) : []
      this.form = this.querySelector("form");
      this.quantityInputs = [this.querySelector("input[name='quantity']"), this.section.querySelector("input[name='quantity']")];

      this.buttonRect = null;

      this.init();

      this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
      this.handleVariantChangeListener = this.handleVariantChange.bind(this);
      this.handleSelectChangeListener = this.handleSelectChange.bind(this);
    }

    init() {
      this.moveOutsideSection();
      this.setInitialPosition();
      this.observeAtcButton();
      this.handleScroll();
      this.syncQuantityInputs();
      this.setBarHeight();
    }

    connectedCallback() {
      window.addEventListener("scroll", this.handleScrollListener, { passive: true });
      this.mainForm?.addEventListener("variant:change", this.handleVariantChangeListener);
      this.select.addEventListener("change", this.handleSelectChangeListener);
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScrollListener);
      this.mainForm?.removeEventListener("variant:change", this.handleVariantChangeListener);
      this.select.removeEventListener("change", this.handleSelectChangeListener);
    }

    setBarHeight() {
      document.documentElement.style.setProperty("--sticky-bar-height", `${this.getBoundingClientRect().height}px`);

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this) {
            document.documentElement.style.setProperty("--sticky-bar-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this);
    }

    handleVariantChange(event) {
      const variant = event.detail.variant;

      if (variant) {
        const element = this.querySelector('[name="id"]');

        element.value = variant.id;
        element.dispatchEvent(new Event("change", { bubbles: true }));

        this.select.value = variant.id;

        this.form.dispatchEvent(new CustomEvent("variant:change", {
          detail: {
            variant: variant
          }
        }));
      }
    }

    handleSelectChange() {
      const option = this.select.options[this.select.selectedIndex];
      const imageSrc = option.dataset.image;
      const variantId = +this.select.value;
      const variant = this.variantsJSON.find((variant) => {
        return variant.id === variantId;
      });

      const element = this.querySelector('[name="id"]');

      element.value = variantId;
      element.dispatchEvent(new Event("change", { bubbles: true }));

      this.mainVariants.forEach((fieldset, index) => {
        const option = variant[`option${index + 1}`];
        const select = fieldset.querySelector("select");
        const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(option)}"]`);

        if (select) {
          select.value = option;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      if (this.image && imageSrc) {
        this.image.src = imageSrc;
        this.image.removeAttribute("srcset");
      }
    }

    syncQuantityInputs() {
      this.quantityInputs.forEach((input) => {
        input.addEventListener("change", () => {
          const value = +input.value;

          this.quantityInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    }

    moveOutsideSection() {
      const existingStickyBar = document.querySelector("body > .sticky-atc-bar");

      existingStickyBar?.remove();

      document.body.appendChild(this);
    }

    setInitialPosition() {
      this.buttonRect = this.atcButton.getBoundingClientRect();
      this.buttonTopOffset = this.atcButton.getBoundingClientRect().top + window.scrollY;
    }

    handleScroll() {
      const scrollY = window.scrollY;

      if (!this.buttonRect) {
        return;
      }

      const isAbove = scrollY > this.buttonTopOffset + this.atcButton.offsetHeight;

      if (isAbove) {
        this.showSticky();
      } else {
        this.hideSticky();
      }
    }

    observeAtcButton() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.setInitialPosition();

            if (entry.isIntersecting) {
              this.hideSticky();
            }
          });
        },
        {
          root: null,
          threshold: 0,
        }
      );

      observer.observe(this.atcButton);
    }

    showSticky() {
      this.classList.add("visible");
      document.body.classList.add("sticky-atc-bar-visible");
      document.body.classList.add(`sticky-atc-bar-position-${this.position}`);
    }

    hideSticky() {
      this.classList.remove("visible");
      document.body.classList.remove("sticky-atc-bar-visible");
    }
  }

  customElements.define("sticky-atc-bar", StickyAtcBar);
}